import { render, staticRenderFns } from "./ParentInfoContainer.vue?vue&type=template&id=3ed20704&scoped=true"
import script from "./ParentInfoContainer.vue?vue&type=script&lang=ts"
export * from "./ParentInfoContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed20704",
  null
  
)

export default component.exports